import { IOutletFiles } from "src/interfaces";

export const composeFiles = (
  currentFiles: IOutletFiles[],
  newFile: IOutletFiles
) => {
  let result = [];
  let isFileNameSame = false;
  result = currentFiles?.map((value) => {
    if (value.name === newFile.name) {
      isFileNameSame = true;
      value.url = newFile.url;
      value.metadata = newFile.metadata;
      value.media_type = newFile.media_type;
      value._destroy = false;
    }

    return value;
  });

  if (!isFileNameSame) {
    result = [...result!, newFile];
  }

  return result;
};
